import { motion } from "framer-motion";
import { Star, Quote } from "lucide-react";
import { useLocalizedContent } from "@/hooks/use-localized-content";
import { useTranslation } from "react-i18next";

const Testimonials = () => {
  const { c } = useLocalizedContent();
  const { t } = useTranslation();
  const badge = c("testimonials_badge", "services.realTestimonials", "Testemunhos reais");
  const sectionTitle = c("testimonials_title", "testimonialsSection.title");
  const sectionSubtitle = c("testimonials_subtitle", "testimonialsSection.subtitle");
  const joinCta = c("testimonials_join_cta", "testimonials.joinCta");
  const bookSession = c("testimonials_cta_text", "testimonials.bookSession");

  const testimonials = [
    {
      name: c("testimonial1_name", "_none_", "Sofia R."),
      text: c("testimonial1_text", "testimonialsSection.testimonial1"),
      stars: 5,
      role: c("testimonial1_role", "_none_", t("testimonials.clientYears", { count: 2 })),
    },
    {
      name: c("testimonial2_name", "_none_", "Ana M."),
      text: c("testimonial2_text", "testimonialsSection.testimonial2"),
      stars: 5,
      role: c("testimonial2_role", "_none_", t("testimonials.clientMonths", { count: 8 })),
    },
    {
      name: c("testimonial3_name", "_none_", "Mariana P."),
      text: c("testimonial3_text", "testimonialsSection.testimonial3"),
      stars: 5,
      role: c("testimonial3_role", "_none_", t("testimonials.clientYears", { count: 1 })),
    },
  ];

  const titleWords = sectionTitle.split(" ");
  const highlight = titleWords.slice(-3).join(" ");
  const before = titleWords.slice(0, -3).join(" ");

  return (
  <section id="testemunhos" className="py-24">
    <div className="container mx-auto px-6">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        className="text-center mb-16"
      >
        <span className="inline-block rounded-full bg-accent px-4 py-1.5 text-xs font-semibold text-accent-foreground mb-4">
          {badge}
        </span>
        <h2 className="font-display text-4xl md:text-5xl font-bold mb-4">
          {before}{" "}
          <span className="text-gradient-wine">{highlight}</span>
        </h2>
        <p className="text-muted-foreground max-w-lg mx-auto text-lg">
          {sectionSubtitle}
        </p>
      </motion.div>

      <div className="grid md:grid-cols-3 gap-8">
        {testimonials.map((tItem, i) => (
          <motion.div
            key={tItem.name}
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: i * 0.15, duration: 0.5 }}
            className="relative rounded-2xl bg-card border border-border p-8 hover:shadow-lg hover:border-primary/20 transition-all duration-300"
          >
            <Quote size={32} className="text-primary/15 absolute top-6 right-6" />
            <div className="flex gap-1 mb-4">
              {Array.from({ length: tItem.stars }).map((_, j) => (
                <Star key={j} size={16} className="fill-primary text-primary" />
              ))}
            </div>
            <p className="text-foreground leading-relaxed mb-6">"{tItem.text}"</p>
            <div className="border-t border-border pt-4">
              <p className="font-display font-bold text-foreground">{tItem.name}</p>
              <p className="text-xs text-muted-foreground">{tItem.role}</p>
            </div>
          </motion.div>
        ))}
      </div>

      <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        className="text-center mt-16"
      >
        <p className="text-muted-foreground mb-6 text-lg">{joinCta}</p>
        <a
          href="#agendar"
          className="inline-flex items-center gap-2 rounded-full bg-primary px-8 py-3.5 text-base font-semibold text-primary-foreground shadow-lg shadow-primary/20 hover:opacity-90 transition-opacity"
        >
          {bookSession}
        </a>
      </motion.div>
    </div>
  </section>
  );
};

export default Testimonials;
